import React, { ReactElement } from 'react';
import './Rules.scss';

const Et: React.FC = (): ReactElement => {
  return (
    <div className="Et rules-wrapper">
      <h2>KAMPAANIAREEGLID</h2>
      <ol className="rules-list">
        <li>
          Kampaania{' '}
          <span className="bold">“Domino – Krõbista vabalt, puruvabalt” </span>{' '}
          on alates <span className="bold">01.08.2026 kuni 31.08.2026 </span>{' '}
          toimuv tarbijamäng (edaspidi kampaania), mida korraldab Fazer Eesti
          OÜ, (asukoht: Pärnu maantee 158/1, Tallinn; edaspidi korraldaja).
        </li>
        <li>
          Kampaania auhinnafondi kuulub{' '}
          <span className="bold">
            3x Schbot F1 robottolmuimeja (valge, Domino kleebistega), väärtusega
            999€, 
          </span>{' '}
          mis loositakse välja 01.09.2026. Auhinnafondi koguväärtus on
          2997€.{' '}
        </li>
        <li>
          Kampaania läbiviimise kord on kehtestatud korraldaja poolt
          käesolevates reeglites. Kõik korraldaja otsused kampaania läbiviimisel
          on lõplikud ning kõigile kampaanias osalejatele kohustuslikud.
        </li>

        <li>
          Kampaaniatooted:
          <table>
            <tr>
              <td>6416453075115</td>
              <td>Domino Original küpsised 175g</td>
            </tr>
            <tr>
              <td>6416453555501</td>
              <td>Domino Küpsised maasikamaitselise täidisega 175g</td>
            </tr>
            <tr>
              <td>6416453075122</td>
              <td>Domino Original küpsised 350g</td>
            </tr>
            <tr>
              <td>6416453074316</td>
              <td>Domino Marianne küpsised 350g</td>
            </tr>
            <tr>
              <td>6416453075917</td>
              <td>Domino Laimimaitselise täidisega küpsised 350g</td>
            </tr>
            <tr>
              <td>6416453077058</td>
              <td>Domino Crunchy choco Nougat 150g</td>
            </tr>
            <tr>
              <td>6416453077065</td>
              <td>Domino Crunchy choco Lemon 150g</td>
            </tr>
            <tr>
              <td>6416453075726</td>
              <td>Domino Fun Avec küpsised 120g</td>
            </tr>
            <tr>
              <td>6416453075733</td>
              <td>Domino Fun Dumle 120g</td>
            </tr>
            <tr>
              <td>6416453083998</td>
              <td>Domino Kakaoküpsised mündi 185g</td>
            </tr>
            <tr>
              <td>6416453077041</td>
              <td>Domino Kakaoküpsised soolakaramelli 185g</td>
            </tr>
          </table>
        </li>
        <li>
          <span className="bold block-span">
            Kampaanias osalemiseks tuleb osta vähemalt üks Domino toode ja
            registreerida ostutšekk interneti kaudu kampaanialehel{' '}
            <a href="http://www.fazer.ee">www.fazer.ee</a>. Kampaanias osalemine
            on tasuta. Auhinna kättesaamiseks tuleb kampaania korraldajale
            esitada ostutšekk.
          </span>

          <span className="block-span">
            Loosimises osalemiseks võib ühe ostutšeki numbri esitada ainult ühe
            korra. Sama ostutšeki mitmekordsel registreerimisel osaleb ainult
            esimesena saabunud registreering.
          </span>

          <span className="bold block-span">Isikuandmete töötlemise kord</span>

          <span className="block-span">
            Fazer Eesti OÜ töötleb kampaania käigus osaleja poolt esitatud
            isikuandmeid vastavalt Eesti Vabariigis kehtivatele seadustele
            kampaania läbiviimise eesmärgil.
          </span>

          <span className="block-span">
            Kampaanias osaleja annab Fazer Eesti OÜ-le nõusoleku töödelda
            esitatud andmeid järgnevatel eesmärkidel:
          </span>

          <span className="block-span">
            <ul>
              <li>kampaania tulemuste kohta kokkuvõtete tegemiseks; </li>
              <li>kampaaniaga seotud koostööpartneritele info edastamiseks;</li>
              <li>võitjate välja loosimiseks ja nende teavitamiseks;</li>
              <li>võitjate nimede avaldamiseks kampaania veebilehel.</li>
            </ul>
          </span>

          <span className="block-span">
            Kampaanias osalejatel on õigus saada lisainfot Fazer Eesti OÜ poolt
            isikuandmete töötlemise kohta. Selleks tuleb saata e-kiri
            aadressile: <a href="mailto:info@fazer.ee">info@fazer.ee</a>{' '}
          </span>

          <span className="block-span">
            Isikuandmete vastutav töötleja on Fazer Eesti OÜ, registrikood
            10057691, Pärnu maantee 158/1, Tallinn 11317; tel 6502421;
            <a href="mailto:info@fazer.ee"> info@fazer.ee</a>
          </span>

          <span className="block-span">
            Kogutud andmeid säilitatakse kolm kuud alates kampaania
            lõpukuupäevast ehk kuni 30.11.2026. Võitjate täielik nimekiri on
            veebilehel üleval kuni 31.07.2026.
          </span>
        </li>
        <li>
          <span className="block-span">
            {' '}
            <span className="bold">01.09.2026</span> loositakse kell 12:00
            kõikide kampaanias osalejate vahel välja{' '}
            <span className="bold">
              3x Schbot F1 robottolmuimeja (valge, Domino kleebistega),
              väärtusega 999€. Auhinnafondi koguväärtus on 2997€.
            </span>
          </span>
          <span className="block-span">
            Auhinna loosimises osalevad kõik veebis registreerunud isikud
            kampaania reeglites esitatud perioodil (alates keskkonna
            avanemisest). Võitjat informeeritakse telefoni või meili teel.
            Loosimise juures viibib vähemalt üks Fazer Eesti OÜ esindaja.
          </span>
        </li>
        <li>
          Auhinna võitja nimi avaldatakse internetis aadressil{' '}
          <a href="http://www.fazer.ee">www.fazer.ee </a>
          hiljemalt loosimisele järgneval kolmandal tööpäeval. Võitjaga võetakse
          korraldaja esindaja poolt ühendust andmete ja auhinna
          kättetoimetamisviisi täpsustamiseks.
        </li>
        <li>
          Juhul, kui auhinna võitja ei vasta korraldaja poolt kehtestatud
          kampaania tingimustele või kui ta ei ole alles hoidnud toote
          ostutšekki, millel oleva numbri ta edastas kampaania korraldajale
          veebi vahendusel, on õigus auhind uuesti välja loosida järgmisele
          isikule. Samuti juhul, kui auhinna võitja ei ole hiljemalt nädala jooksul alates, tema kui auhinna võitja nime avalikustamist internetis aadressil{' '}
          <a href="http://www.fazer.ee">www.fazer.ee</a> olnud veebis esitatud
          kontaktandmetel kättesaadav andmete täpsustamiseks, on korraldajal
          õigus jätta talle auhind üle andmata ning korraldada uus
          loosimine.{' '}
        </li>
        <li>
          Korraldajalt ükskõik missuguse kampaania auhinna saaja annab loa
          korraldajale kasutada võitja nime meedias, reklaamides,
          PR-kampaaniates jms üritustel ilma võitjale selle eest täiendavat tasu
          maksmata ja vastavat kokkulepet sõlmimata.{' '}
        </li>
        <li>
          Kampaania käigus kampaanias osaleja poolt võidetud auhinda ei asendata
          võitja nõudmisel teist liiki auhinnaga ega hüvitata võitjale auhinna
          maksumust rahas, v.a juhul, kui auhind asendatakse teise samaväärse
          auhinnaga korraldaja otsusel.{' '}
        </li>
        <li>
          Auhinna võitjale üleandmisega seotud riiklikud maksud tasub korraldaja
          Eesti Vabariigi seadustes sätestatud korras ja tähtaegadel.{' '}
        </li>
        <li>
          Kampaanias osaleja poolt kampaania tingimuste eiramise või
          korraldajale enda kohta valede või ebatäpsete andmete esitamise
          korral, samuti muude ebaõnnestumiste korral (korraldajal ei õnnestu
          auhinna võitjaga kontakti saada), mis ei ole tingitud korraldaja
          süüst, ei vastuta korraldaja kampaanias osaleja auhindade loosimisest
          või auhinna kätteandmisest kõrvalejäämise eest.{' '}
        </li>
        <li>
          Vääramatu jõu (force majeure) asjaolude ilmnemisel on korraldajal
          ühepoolne õigus katkestada kampaania ja jätta auhinnad välja loosimata
          ja/või auhinnad võitjatele üle andmata, teatades sellest koheselt
          kampaanias osalejatele meedia vahendusel.{' '}
        </li>
        <li>
          Kõik kampaaniast tulenevad vaidlused lahendatakse vastavalt Eesti
          Vabariigi seadusandlusele.
        </li>
        <li>
          Kõik pretensioonid seoses kampaania korraldamise ja/või läbiviimisega
          tuleb saata kirjalikult kampaania korraldaja asukohta: Pärnu maantee
          158/1, 11317 Tallinn märksõnaga “KAMPAANIA" hiljemalt 01.09.2026.
          Kaebused, mis esitatakse peale nimetatud kuupäeva, ei võeta menetluse.
          Laekunud pretensioonidele vastatakse 3 tööpäeva jooksul. Kampaania
          lisainfo telefonil 650 2421;{' '}
          <a href="mailto:info@fazer.ee">info@fazer.ee</a>{' '}
        </li>
      </ol>
    </div>
  );
};

export default Et;
